import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import './styles/avds-adapter.css';
import './styles/app.css';

createRoot(document.getElementById('root')!).render(
  <React.StrictMode><App /></React.StrictMode>,
);

if ('serviceWorker' in navigator && window.isSecureContext) {
  window.addEventListener('load', () => void navigator.serviceWorker.register('/sw.js').catch(() => undefined), { once: true });
}
